import React, { useState } from "react";
import { Badge } from "../../../../../UI toolkit/Button/Button";
import { P, SubHeader } from "../../../../../UI toolkit/Text/Text";
import {
  TransactionsTableStyle,
  TransactionsTableHeaderStyle,
} from "./P2POrders.styled";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import { connect } from "react-redux";
import { capitalizeFirstLetter } from "../../../../../utils/specialFunctions";
import ic_sent_icon from "../../../../../assets/images/ic-sent-coin.svg";
import ic_receive_icon from "../../../../../assets/images/ic-received-coin.svg";
import P2POrdersModal from "./P2POrdersModal";

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

// Redux store mapstatetoprops and mapdispatchtoprops

const P2POrdersTable = ({ links1, pagination, getSavings }) => {
  const [order, setOrder] = React.useState(null);
  const [openModal, setopenModal] = useState(false);
  const [saving, setSaving] = useState(null);

  const statusKeys = {
    stopped: "broken",
    active: "ongoing",
    completed: "completed",
    pending: "pending",
    paid: "paid",
  };

  const bgColor = (status) => {
    return status === "active" || status === "pending"
      ? "#FFEAB6"
      : status === "completed" || status === "paid"
      ? "#D1F7C4"
      : status === "stopped"
      ? "#FFDCE5"
      : "";
  };

  const color = (status) => {
    return status === "active" || status === "pending"
      ? "#606060"
      : status === "completed" || status === "paid"
      ? "#606060"
      : status === "stopped"
      ? "#531423"
      : "";
  };

  const rowsOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  return (
    <div style={{ overflowX: "auto" }}>
      <TransactionsTableHeaderStyle className="w-full">
        <tbody className="w-full">
          <tr className="Table-heading -px-1.5">
            <td width="20%" className="pt-4 pb-4"></td>

            <td width="15%" className="pt-4 pb-4">
              USER
            </td>

            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  PRICE RATE
                </SubHeader>
              </div>
            </td>
            <td width="10%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  QUANTITY
                </SubHeader>
              </div>
            </td>
            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  MERCHANT
                </SubHeader>
              </div>
            </td>

            <td width="25%" className="pt-4 pb-4"></td>
          </tr>
        </tbody>
      </TransactionsTableHeaderStyle>
      {links1 &&
        links1.map((transactionGroup, idx, arr) => {
          return (
            <TransactionsTableStyle className="w-full" key={idx}>
              <tbody>
                <tr>
                  <td colSpan="5">
                    <div className="pt-4 pb-4 px-1.5">
                      <P fontSize="13px" color={"#7C8191"} fontWeight="500">
                        {`${timeAgo.format(
                          new Date(transactionGroup.group)
                        )} — ${new Date(
                          transactionGroup.group
                        ).toDateString()}`}
                      </P>
                    </div>
                  </td>
                </tr>

                {transactionGroup.data.map((curr, idx, arr) => {
                  return (
                    // <pre>{JSON.stringify(curr, null, 2)}</pre>
                    <tr
                      className="px-1.5"
                      style={{ borderBottom: "1px solid #EFF0F5" }}
                      key={idx}
                    >
                      <td width="15%" className="pt-4 pb-4 px-1.5">
                        <Badge
                          color={color(curr.status)}
                          bg={bgColor(curr.status)}
                        >
                          {curr.status}
                        </Badge>
                      </td>
                      <td width="15%">
                        <div className="flex justify-center items-start">
                          <P fontSize="13px" color={"#374072"} fontWeight="500">
                            {curr?.ad?.action === "buy" ? "Buy" : "Sell"}
                          </P>
                        </div>
                      </td>

                      <td width="15%">
                        <div className="">
                          <P fontSize="13px" color={"#374072"} fontWeight="500">
                            {curr?.account?.email}
                          </P>
                        </div>
                      </td>
                      <td width="15%">
                        <div className="flex justify-center items-start">
                          <P fontSize="13px" color={"#374072"} fontWeight="500">
                            NGN {curr?.price}/ USDT
                          </P>
                        </div>
                      </td>
                      <td width="15%">
                        <div className="flex justify-center">
                          <div>
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              {`${
                                curr?.ad?.action === "sell"
                                  ? curr?.ad.source_currency
                                  : curr?.ad?.action === "buy"
                                  ? curr?.ad?.destination_currency
                                  : ""
                              }${Number(curr?.quantity).toFixed(2)}`}
                            </P>
                            <P
                              fontSize="10px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              NGN
                              {Number(curr?.quantity * curr?.price)
                                .toFixed(2)
                                .toLocaleString()}
                            </P>
                          </div>
                        </div>
                      </td>
                      <td width="15%">
                        <div className="flex justify-center">
                          <div>
                            <P
                              fontSize="13px"
                              color={"#7A809B"}
                              fontWeight="400"
                            >
                              {curr?.ad?.account?.email}
                            </P>
                            <P
                              fontSize="10px"
                              color={"#7A809B"}
                              fontWeight="500"
                            >
                              {curr?.ad?.p2p_profile?.username}
                            </P>
                          </div>
                        </div>
                      </td>
                      <td width="15%" className="pt-4 pb-4 px-1.5">
                        <div className="flex justify-center">
                          <div className="">
                            <P
                              fontSize="13px"
                              color={"#0087B5"}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setOrder(curr);
                                setopenModal(true);
                              }}
                            >
                              View
                            </P>
                          </div>
                        </div>
                      </td>
                      <td width="15%" className="pt-4 pb-4 px-1.5">
                        <div className="flex justify-center"></div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </TransactionsTableStyle>
          );
        })}
      <div>
        {openModal ? (
          <P2POrdersModal
            width={"30%"}
            border={"none"}
            closeModalCallback={() => {
              setopenModal(false);
            }}
            order={order}
          />
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    pagination: state.savings.pagination,
  };
};

// Link Actions to components
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(P2POrdersTable);
